// extracted by mini-css-extract-plugin
export var sectionTitle = "cob-section-module--section-title--A2zmH";
export var sectionList = "cob-section-module--section-list--nJO1b";